module.exports = __webpack_public_path__ + "static/img/8.cc813e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/sp/8.png
// module id = 2aEN
// module chunks = 0